<span class="mainheader">{{ model?.title ?? "Security Groups" }}</span>
<div class="droplistgroup" cdkDropListGroup>
  <div class="select-container">
    <h2 class="listheader">Current</h2>

    <div cdkDropList
         [cdkDropListData]="current"
         class="select-list"
         (cdkDropListDropped)="drop($event)">
      @for (item of current; track item) {
    
      <div class="select-box" cdkDrag>
        <label *ngIf="enableSorting">
          <input type="checkbox"
                 [checked]="isInSortOrder(item.fieldProfile?.fieldName)"
                 (change)="toggleSortField(item.fieldProfile?.fieldName)" />
          {{ item.caption || item.fieldProfile?.displayName }}
        </label>

        <span *ngIf="!enableSorting">
          {{ item.caption || item.fieldProfile?.displayName }}
        </span>

        <button *ngIf="enableSorting && isInSortOrder(item.fieldProfile?.fieldName)"
                class="sort-toggle"
                (click)="toggleSortDirection(item.fieldProfile?.fieldName)">
          {{ getSortDirection(item.fieldProfile?.fieldName) ? '↑' : '↓' }}
        </button>
      </div>

      }
    </div>
    <button class="nav-btn" (click)="moveAllRight()">Remove All</button>
    <div class="sort-help" *ngIf="enableSorting">
      <p>
        <strong>Sorting Help:</strong><br />
        Check fields to include in sorting.<br />
        Click <span class="arrow">↑</span>/<span class="arrow">↓</span> to change direction.
      </p>
    </div>
  </div>
  <div class="select-container">
    <h2 class="listheader">Available</h2>

    <div cdkDropList
         [cdkDropListData]="available"
         class="select-list"
         (cdkDropListDropped)="drop($event)">
      @for (item of available; track item) {
      <div class="select-box" cdkDrag>{{ item.caption }}</div>
      }
    </div>

    <button class="nav-btn" (click)="moveAllLeft()">Add All</button>
  </div>
</div>

<button *ngIf="onSave" class="save-btn" (click)="saveChanges()">Save Changes</button>
